import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import CircularProgress from '@mui/material/CircularProgress'
import HistoryIcon from '@mui/icons-material/History'
import CardAccordion from '../card/cardWithAccordion'

const HistoriqueDeLivraison = ({
  order,
  orderHistoriqueLivraison,
  isLoadingHistoriqueLivraison,
  getOrderHistoriqueLivraison,
  isLoading,
}) => {
  useEffect(() => {
    if (order?.code) {
      getOrderHistoriqueLivraison(order.code)
    }
  }, [order])
  return (
    <CardAccordion
      icon={
        <HistoryIcon style={{ marginRight: '4px', width: '20px', height: '20px' }} />
      }
      title={'Historique de Livraison'}
      content={
        <>
          {isLoadingHistoriqueLivraison || isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '20px',
              }}
            >
              <CircularProgress color="primary" />
            </div>
          ) : (
            <>
              {orderHistoriqueLivraison.length > 0 ? (
                <div style={{ padding: '5px 5px 10px' }}>
                  {orderHistoriqueLivraison.map((rdv, i) => {
                    return (
                      <div key={i} style={{ paddingBottom: '5px' }}>
                        <div
                          style={{
                            color: '#696969',
                            fontSize: '14px',
                            fontWeight: '400',

                            paddingLeft: '25px',
                            textTransform: 'capitalize',
                          }}
                        >
                          {rdv.date}
                        </div>
                        {rdv.historyDeliveryDetails.map((step, i) => (
                          <div
                            key={i}
                            style={{
                              display: 'flex',
                              padding: '10px 40px',
                              borderBottom: '1px solid #f5f5f5',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                marginRight: '10px',
                              }}
                            >
                              {step.hour}
                            </span>
                            <span
                              style={{
                                fontSize: '14px',
                                fontWeight: '450',
                                wordBreak: 'break-word',
                              }}
                            >
                              {step.message}
                            </span>
                          </div>
                        ))}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: '20px',
                  }}
                >
                  <span
                    style={{
                      overflowWrap: 'break-word',
                      fontSize: '12px',
                      fontWeight: '550',
                    }}
                  >
                    {'Historique de Livraison est vide'}
                  </span>
                </div>
              )}
            </>
          )}
        </>
      }
    />
  )
}
HistoriqueDeLivraison.propTypes = {
  order: PropTypes.object,
  orderHistoriqueLivraison: PropTypes.array,
  isLoadingHistoriqueLivraison: PropTypes.bool,
  getOrderHistoriqueLivraison: PropTypes.func,
  isLoading: PropTypes.bool,
}
export default HistoriqueDeLivraison
